import { createSlice } from "@reduxjs/toolkit";

const initialState = {
	show: false,
	variants: [],
	selectedVariant: null,
	selectionContext: null,
	feedback: "",
	statusCode: undefined,
};

export const VariantValidatorSlice = createSlice({
	name: "variantValidator",
	initialState,
	reducers: {
		openVariantValidator: (state, action) => {
			state.show = true;
			state.variants = action.payload.variants;
			state.selectedVariant = null;
			state.selectionContext = action.payload.selectionContext;
			state.feedback = action.payload.feedback;
			state.statusCode = action.payload.statusCode;
		},
		closeVariantValidator: (state) => {
			state.show = false;
		},
		selectVariant: (state, action) => {
			state.selectedVariant = action.payload;
			state.show = false;
		},
		resetVariantValidator: () => initialState,
	},
});

export const {
	openVariantValidator,
	closeVariantValidator,
	selectVariant,
	resetVariantValidator,
} = VariantValidatorSlice.actions;

export const selectVariantValidatorShow = (state) =>
	state.variantValidator.show;

export const selectVariantValidatorVariants = (state) =>
	state.variantValidator.variants;

export const selectSelectedVariant = (state) =>
	state.variantValidator.selectedVariant;

export const selectVariantSelectionContext = (state) =>
	state.variantValidator.selectionContext;

export const selectVariantValidatorFeedback = (state) =>
	state.variantValidator.feedback;

export const selectVariantValidatorStatusCode = (state) =>
	state.variantValidator.statusCode;

export default VariantValidatorSlice.reducer;
